import { useEffect, useState } from "react";
import LoadingGif from "../../assets/Assetstest/Logo.png";
import LoadingGifTwo from "../../assets/Assetstest/forumhero.png";
import LoadingGifThree from "../../assets/Assetstest/forumhero1.png";
import "./loader.css";

const Loader = () => {
  const textArray = [
    "Survive the darkness...",
    "Build kingdoms. Forge alliances.",
    "Every battle is a fight for survival.",
    "Sharpen your blade. The hunt begins.",
    "Only the strong will endure.",
    "Prepare for the ultimate survival challenge.",
    "Gather resources. Defend your land.",
    "Face brutal enemies and conquer.",
    "Craft. Fight. Survive.",
    "The world is unforgiving. Are you ready?",
  ];

  const backgroundArray = [LoadingGif, LoadingGifTwo, LoadingGifThree];

  const getRandomIndex = (arrayLength: number) => Math.floor(Math.random() * arrayLength);

  const [currentTextIndex, setCurrentTextIndex] = useState(getRandomIndex(textArray.length));
  const [currentBackgroundIndex, setCurrentBackgroundIndex] = useState(0);
  const [fadeClass, setFadeClass] = useState("fade-in");

  useEffect(() => {
    const textInterval = setInterval(() => {
      setFadeClass("fade-out");
      setTimeout(() => {
        setCurrentTextIndex(getRandomIndex(textArray.length));
        setFadeClass("fade-in");
      }, 500);
    }, 5000);

    return () => clearInterval(textInterval);
  }, [textArray.length]);

  useEffect(() => {
    const bgInterval = setInterval(() => {
      setCurrentBackgroundIndex((prevIndex) => (prevIndex + 1) % backgroundArray.length);
    }, 10000);

    return () => clearInterval(bgInterval);
  }, [backgroundArray.length]);

  return (
    <div
      className="loader"
      style={{
        backgroundImage: `url(${backgroundArray[currentBackgroundIndex]})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="loader__image">
        <div className="SurvivalInteractive__loader">
          <h1 className={`loading__text ${fadeClass}`}>
            {textArray[currentTextIndex]}
          </h1>
        </div>
        <div className="loading-bar">
          <div className="loader-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
